import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { getRecordOfAdverseReactionDetail, getRecordOfAdverseReactionExport, getRecordOfAdverseReactionList, getRecordOfAdverseReactionSubmit, getRemove, RecordOfAdverseReactionListParams, SubmitParams } from "../../../services/recordOfAdverseReaction";

// 列表
export const getRecordOfAdverseReactionListAsync = createAsyncThunk<
  void,
  RecordOfAdverseReactionListParams,
  RootThunkApi<void>
>('recordOfAdverseReaction/getRecordOfAdverseReactionListAsync', async (params, api) => {
  return sendAsync(getRecordOfAdverseReactionList(params), api)
})


// 详情
export const getRecordOfAdverseReactionDetailAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'recordOfAdverseReaction/getRecordOfAdverseReactionDetailAsync',
  async (params, api) => {
    return sendAsync(getRecordOfAdverseReactionDetail(params), api)
  }
)


// 保存编辑
export const getRecordOfAdverseReactionSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'recordOfAdverseReaction/getRecordOfAdverseReactionSubmitAsync',
  async (params, api) => {
    return sendAsync(getRecordOfAdverseReactionSubmit(params), api)
  }
)

//导出
export const getRecordOfAdverseReactionExportAsync = createAsyncThunk<
  void,
  RecordOfAdverseReactionListParams,
  RootThunkApi
>('drugQualityFile/getRecordOfAdverseReactionExportAsync ', async (params, api) => {
  return sendAsync(getRecordOfAdverseReactionExport(params), api)
})


// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'drugQualityFile/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
